export interface AppVersionInfo {
    environment: string;
    version: string;
}

export interface AppVersionChange {
    current: string;
    pending: string;
}

export enum AppVersionEvent {
    Version = "Version",
}

export type AppVersionHubHandler = (version: string) => void;

export type AppVersionUpdateAction = (version: string) => void;

export interface AppVersionHubSubscription {
    handler: AppVersionHubHandler;
    event: AppVersionEvent;
    listener?: string;
}

export enum SwVersionEvent {
    Ready = "VERSION_READY",
    Detected = "VERSION_DETECTED",
    NoDetected = "NO_NEW_VERSION_DETECTED",
    InstallationFailed = "VERSION_INSTALLATION_FAILED"
}